(() => {
  'use strict';
  if (window.dhaProductSelectors) return;
  window.dhaProductSelectors = true;
  const translations = {
    da: ['Vælg størrelse', 'Luk', 'Udsolgt', 'Se flere farver', 'Størrelse'],
    en: ['Choose size', 'Close', 'Sold out', 'More colours', 'Size'],
    de: ['Größe wählen', 'Schließen', 'Ausverkauft', 'Weitere Farben', 'Größe'],
    sv: ['Välj storlek', 'Stäng', 'Slutsåld', 'Fler färger', 'Storlek'],
    nl: ['Kies maat', 'Sluiten', 'Uitverkocht', 'Meer kleuren', 'Maat'],
    fr: ['Choisir la taille', 'Fermer', 'Épuisé', 'Plus de couleurs', 'Taille'],
    pl: ['Wybierz rozmiar', 'Zamknij', 'Wyprzedane', 'Więcej kolorów', 'Rozmiar']
  };
  const t = translations[document.documentElement.lang.split('-')[0]] || translations.en;
  const node = (tag, cls, text) => {
    const el = document.createElement(tag);
    el.className = cls;
    if (text) el.textContent = text;
    return el;
  };
  function bindDisclosure(trigger, dialog, closers) {
    let oldOverflow = '';
    trigger.setAttribute('aria-haspopup','dialog');
    dialog.classList.remove('dha-inline-sheet');
    trigger.addEventListener('click',()=>{
      if(dialog.open){dialog.close();return;}
      oldOverflow=document.body.style.overflow;
      dialog.showModal();document.body.style.overflow='hidden';
      trigger.setAttribute('aria-expanded','true');
    });
    closers.forEach(button=>button.addEventListener('click',()=>dialog.close()));
    dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
    dialog.addEventListener('close',()=>{document.body.style.overflow=oldOverflow;trigger.setAttribute('aria-expanded','false');if(trigger.isConnected)trigger.focus({preventScroll:true});});
  }
  function enhance(root) {
    const info = root.querySelector('.m-product-info--wrapper');
    if (!info) return;
    const titleBlock=info.querySelector('.main-product__block-title');
    const ratingBlock=info.querySelector('.loox-rating')?.closest('.main-product__block');
    if(titleBlock && ratingBlock && !titleBlock.closest('.dha-product-heading')){
      const heading=node('div','dha-product-heading');titleBlock.before(heading);heading.append(titleBlock,ratingBlock);
    }
    const positionQuantity = () => {
      const trigger = info.querySelector('.dha-size-trigger');
      const quantity = info.querySelector('.m-product-form--main .m-product-form--input');
      if (!trigger || !quantity || trigger.closest('.dha-size-quantity-row')) return;
      const row = node('div', 'dha-size-quantity-row');
      trigger.before(row); row.append(trigger, quantity);
    };
    positionQuantity();
    let images = {};
    try { images = JSON.parse(root.querySelector('[data-dha-product-images]')?.textContent || '{}'); } catch (_) {}
    info.querySelectorAll('.pl-swatches__group--colors').forEach(group => {
      if (group.dataset.dhaReady) return;
      const track = group.querySelector('.pl-swatches__container');
      if (!track || !track.children.length) return;
      group.dataset.dhaReady = 'true';
      group.classList.add('dha-colors');
      track.querySelectorAll('.pl-swatches__link').forEach(link => {
        const label = link.querySelector('.pl-swatches__tooltip')?.textContent.trim() || link.getAttribute('aria-label');
        const image = images[link.dataset.handle]?.image;
        if (image) {
          const img = node('img', 'dha-color-image');
          img.src = image; img.alt = ''; img.width = 104; img.height = 104; img.loading = 'lazy';
          img.addEventListener('error', () => { img.remove(); link.classList.remove('dha-has-image'); }, {once:true});
          link.prepend(img); link.classList.add('dha-has-image');
        }
        link.append(node('span', 'dha-color-name', label));
        const pricing=images[link.dataset.handle];
        if(pricing && Number(pricing.compareAt)>Number(pricing.price) && Number(pricing.price)>=0){
          const discount=Math.round((Number(pricing.compareAt)-Number(pricing.price))*100/Number(pricing.compareAt));
          if(discount>0)link.append(node('span','dha-color-discount',discount+'%'));
        }
        if (link.getAttribute('aria-disabled') === 'true') link.append(node('span', 'dha-sold-out', t[2]));
      });
      const links = [...track.querySelectorAll('.pl-swatches__link')];
      if (!links.length) return;
      // Canonical names come from the products, not their translated labels.
      const palette = ['hvid','cream','creme','sand','lysegul','karry','orange','karamel','mokka','brun','rose','lyserød','magenta','rød','bordeaux','bourgogne','mørkelilla','violet','lavendel','lyslilla','kongeblå','støvet blå','isblå','petroleum','mint','salvie grøn','jade grøn','olivengrøn','mørkegrøn','grå','sort'];
      const normalize = value => (value || '').toLocaleLowerCase('da').trim();
      const rank = link => { const name = normalize(images[link.dataset.handle]?.color || link.querySelector('.dha-color-name')?.textContent); const index = palette.indexOf(name); return index < 0 ? palette.length : index; };
      const unavailable = link => link.getAttribute('aria-disabled') === 'true' || images[link.dataset.handle]?.available === false;
      links.sort((a,b) => Number(unavailable(a))-Number(unavailable(b)) || rank(a)-rank(b) || a.textContent.localeCompare(b.textContent));
      const dialog = node('dialog','dha-size-dialog dha-color-dialog');
      const label = group.querySelector('.pl-swatches__label')?.textContent.trim() || t[3];
      dialog.setAttribute('aria-label',label);
      const head = node('div','dha-size-head');
      head.append(node('h2','dha-size-title',label));
      const close = node('button','dha-size-close','×'); close.type='button'; close.setAttribute('aria-label',t[1]); head.append(close); dialog.append(head);
      const availableGrid = node('div','dha-color-grid'); dialog.append(availableGrid);
      const sold = node('div','dha-color-grid');
      links.forEach(link => {
        if(unavailable(link)) {
          link.setAttribute('aria-disabled','true');
          if(!link.querySelector('.dha-sold-out')) link.append(node('span','dha-sold-out',t[2]));
          sold.append(link);
        } else availableGrid.append(link);
      });
      if(!availableGrid.children.length) availableGrid.remove();
      if(sold.children.length){dialog.append(node('h3','dha-color-sold-heading',t[2]),sold);}
      group.append(dialog);
      track.classList.add('dha-color-preview');
      const desktop=matchMedia('(min-width: 768px)');
      const more = node('button','dha-colors-more'); more.type='button';
      function renderPreview(){
        track.replaceChildren();
        const count=desktop.matches?5:3;
        const inStock=links.filter(link=>!unavailable(link));
        const pool=inStock.length>=count?inStock:links;
        const selected=links.find(link=>link.getAttribute('aria-current')==='page');
        const start=Math.max(0,Math.min(pool.indexOf(selected),pool.length-count));
        let preview=pool.slice(start,start+count);
        if(selected && !preview.includes(selected))preview=[selected,...preview.slice(0,count-1)];
        links.forEach(link=>link.classList.toggle('dha-preview-duplicate',preview.includes(link)));
        preview.forEach(link=>{const copy=link.cloneNode(true);copy.classList.remove('dha-preview-duplicate');copy.removeAttribute('id');copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));track.append(copy);});
        more.replaceChildren(node('strong','','+'+(links.length-preview.length)),node('span','',t[3]));
        more.hidden=links.length<=preview.length;
        more.setAttribute('aria-label',t[3]+' ('+links.length+')');track.append(more);
      }
      renderPreview();desktop.addEventListener('change',renderPreview);
      bindDisclosure(more,dialog,[close]);
    });
    const sizeGroups = [...info.querySelectorAll('.pl-swatches__group--pills')].filter(g => !g.closest('dialog') && /^(height|højde|höhe|höjd|hauteur|hoogte|wysokość|diameter|diamètre|durchmesser|średnica)/i.test(g.querySelector('[role="group"]')?.getAttribute('aria-label') || ''));
    if (!sizeGroups.length || info.querySelector('.dha-size-trigger')) return;
    const dialog = node('dialog','dha-size-dialog');
    dialog.setAttribute('aria-label',t[0]);
    const head = node('div','dha-size-head');
    head.append(node('h2','dha-size-title',t[0]));
    const close = node('button','dha-size-close','×'); close.type='button'; close.setAttribute('aria-label',t[1]);
    head.append(close); dialog.append(head);
    const trigger = node('button','dha-size-trigger'); trigger.type='button'; trigger.setAttribute('aria-haspopup','dialog'); trigger.setAttribute('aria-expanded','false');
    const summary = sizeGroups.map(g => g.querySelector('.pl-swatches__label')?.textContent.trim()).filter(Boolean).map(label => /\bcm\b/i.test(label) ? label : label + ' cm').join(' · ');
    trigger.append(node('span','dha-size-summary',summary),node('span','dha-size-chevron','⌄'));
    sizeGroups[0].before(trigger,dialog);
    sizeGroups.forEach(group => {
      group.querySelectorAll('.pl-swatches__link').forEach(link => {
        if (!/\bcm\b/i.test(link.textContent)) link.append(node('span','dha-size-unit','cm'));
      });
      group.querySelectorAll('[aria-disabled="true"]').forEach(link => link.append(node('span','dha-sold-out',t[2])));
      dialog.append(group);
    });
    positionQuantity();
    const done = node('button','dha-size-done',t[1]); done.type='button'; dialog.append(done);
    bindDisclosure(trigger,dialog,[close,done]);
  }
  function enhanceContent() {
    document.querySelectorAll('[data-dha-content]:not([data-ready])').forEach(root => {
      root.dataset.ready='true';
      const panels=[...root.querySelectorAll('.dha-content-panel')];
      const nav=root.querySelector('.dha-content-nav');
      const media=matchMedia('(min-width: 768px)');
      let active=0;
      const tabs=panels.map((panel,index)=>{
        const button=node('button','dha-content-tab',panel.querySelector('summary').textContent.trim());button.type='button';button.id=panel.id+'-tab';button.setAttribute('role','tab');button.setAttribute('aria-controls',panel.id);
        button.addEventListener('click',()=>{active=index;sync();});nav.append(button);return button;
      });
      function sync(){
        nav.hidden=!media.matches;
        panels.forEach((panel,index)=>{
          panel.hidden=media.matches && index!==active;
          if(media.matches){panel.open=true;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tabs[index].id);}
          else{panel.removeAttribute('role');panel.removeAttribute('aria-labelledby');panel.open=false;}
          tabs[index].setAttribute('aria-selected',String(index===active));tabs[index].tabIndex=index===active?0:-1;
        });
      }
      nav.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();active=event.key==='Home'?0:event.key==='End'?tabs.length-1:(active+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;sync();tabs[active].focus();
      });
      media.addEventListener('change',sync);sync();
      document.addEventListener('click',event=>{
        const link=event.target.closest('a[href*="#loox"],.loox-rating');
        if(!link)return;
        const index=panels.findIndex(panel=>panel.querySelector('#looxReviews,[data-loox-widget]'));
        if(index>=0){active=index;if(media.matches)sync();else panels[index].open=true;}
      },true);
    });
    document.querySelectorAll('[data-dha-countdown]:not([data-ready])').forEach(el=>{
      el.dataset.ready='true';const end=Date.parse(el.dataset.dhaCountdown);
      if(!Number.isFinite(end)){el.hidden=true;return;}
      const digits=[...el.querySelectorAll('[data-digit]')];
      function update(){
        const remaining=Math.max(0,Math.floor((end-Date.now())/1000));
        if(!remaining){el.hidden=true;return false;}
        el.hidden=false;
        const values=[Math.floor(remaining/86400),Math.floor(remaining/3600)%24,Math.floor(remaining/60)%60,remaining%60];
        digits.forEach((digit,index)=>{const value=String(values[index]).padStart(2,'0');if(digit.textContent!==value)digit.textContent=value;});return true;
      }
      if(update()){const timer=setInterval(()=>{if(!el.isConnected||!update())clearInterval(timer);},1000);}
    });
  }

  function init() { enhanceContent(); document.querySelectorAll('product-info[data-section-type="product-page"]').forEach(enhance); }
  let pending=false;
  const observer=new MutationObserver(()=>{if(!pending){pending=true;requestAnimationFrame(()=>{pending=false;init();});}});
  const start=()=>{init(); const main=document.getElementById('MainContent');if(main) observer.observe(main,{childList:true,subtree:true});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  // Keep the native product links and checkout form. Only remember the viewport during a product selection.
  document.addEventListener('click',event=>{
    const link=event.target.closest('.dha-colors .pl-swatches__link, .dha-size-dialog .pl-swatches__link');
    if(!link)return;
    if(link.getAttribute('aria-disabled')==='true'||link.getAttribute('aria-current')==='page'){event.preventDefault();event.stopImmediatePropagation();return;}
    if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;
    try{sessionStorage.setItem('dha-selector-navigation',JSON.stringify({path:new URL(link.href).pathname.replace(/\/$/,''),y:window.scrollY,time:Date.now()}));}catch(_){}
  },true);
  window.addEventListener('load',()=>{
    try{const saved=JSON.parse(sessionStorage.getItem('dha-selector-navigation')||'null');sessionStorage.removeItem('dha-selector-navigation');if(saved&&Date.now()-saved.time<15000&&location.pathname.replace(/\/$/,'')===saved.path)window.scrollTo({top:saved.y,behavior:'instant'});}catch(_){}
  },{once:true});
})();




